import { baseRoutes } from "@/api/base-routes";
import { packNetAxios } from "@/lib/api-client";

const cvpRangeApi = `${baseRoutes.cvpRange}/api/v1/machines`;

export async function deleteCvpRangeMachine(id: string): Promise<void> {
	await packNetAxios.delete(`${cvpRangeApi}/${id}`);
}
